import React, { useContext } from 'react'

import classes from './Table.module.scss'

interface TableProps {
  hover?: boolean
  strip?: boolean
}

interface TableContext {
  hover: boolean
  strip: boolean
}

const Context = React.createContext<TableContext>(undefined!)

export function useTableContext() {
  return useContext(Context)
}

export const Table: React.FC<TableProps> = ({ children, ...props }) => {
  const context: TableContext = {
    hover: Boolean(props.hover),
    strip: Boolean(props.strip)
  }
  return (
    <Context.Provider value={context}>
      <div className={classes.table}>{children}</div>
    </Context.Provider>
  )
}
